/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el       = $(el);
const $wrapper  = $el.find('.modal-videos-wrapper');
const $player   = $el.find('.player');
const $btnplay  = $('[data-play-ytb-modal]');
const $btnClose = $el.find('.btn-close');

let isOpened = false;

let player;

const removerAcentos = (str) => {
    var w,
        map = {
            a: /[\xE0-\xE6]/g,
            e: /[\xE8-\xEB]/g,
            i: /[\xEC-\xEF]/g,
            o: /[\xF2-\xF6]/g,
            u: /[\xF9-\xFC]/g,
            c: /\xE7/g,
            n: /\xF1/g
        };

    str = str.replace(/[?!.,@#$%&()]/g, '');
    str = str.replace(/ +\| +/g, ' ');

    for (w in map) {
        str = str.replace(map[w], w);
    }

    return str;
};

const toSlug = (str) => removerAcentos(str).split(/\s|_|(?=[A-Z])/).join('-').toLowerCase();

Player.load(() => {
    player = new Player($player.get(0));

    player.on('ready', function () {
        $el.trigger('player:loaded', [this.videoSlug]);
    });

    player.on('playing', function () {
        $document.trigger('video-sadia.playing', [this.videoSlug]);
    });

    player.on('paused', function () {
        $document.trigger('video-sadia.paused', [this.videoSlug]);
    });

    player.on('ended', function () {
        $document.trigger('video-sadia.ended', [this.videoSlug]);
    });

    player.on('progress:25', function () {
        $document.trigger('video-sadia.progress', [this.videoSlug, 25, this.videoType]);
    });

    player.on('progress:50', function () {
        $document.trigger('video-sadia.progress', [this.videoSlug, 50, this.videoType]);
    });

    player.on('progress:75', function () {
        $document.trigger('video-sadia.progress', [this.videoSlug, 75, this.videoType]);
    });

    player.on('progress:100', function () {
        $document.trigger('video-sadia.progress', [this.videoSlug, 100, this.videoType]);
    });
});

const open = (videoId, videoSlug, videoType) => {
    isOpened = true;

    const scrollTop = $window.scrollTop();

    $body.addClass('modal-opened');

    TweenLite.set($el, { top: '-100%', display: 'block', opacity: 1 });
    TweenLite.set($btnClose, { display: 'block', opacity: 0 });
    TweenLite.set($player, { display: 'block', opacity: 0 });

    if (typeof player != 'undefined') {
        player.setVideo(videoId, videoSlug, videoType);
        player.play();
    } else {
        $el.on('player:loaded', function() {
            player.setVideo(videoId, videoSlug, videoType);
            player.play();
        });
    }

    TweenLite.to($el, .8, {
        top: '0%',
        ease: Expo.easeInOut,
        onComplete() {
            TweenLite.to($btnClose, .4, { opacity: 1 });
            TweenLite.to($player, .4, { opacity: 1 });
        }
    });
};

const close = () => {
    isOpened = false;

    $body.removeClass('modal-opened');

    if (typeof player != 'undefined') {
        player.pause();
    }

    TweenLite.to($el, .8, {
        top: '100%',
        ease: Expo.easeInOut,
        onComplete() {
            TweenLite.set($el, { display: 'none' });
        }
    });
};

$el.on('modal:open', function (e, videoId, videoSlug) {
    open(videoId, videoSlug);
});

$el.on('modal:close', function () {
    close();
});

$btnClose.on('click', function () {
    close();
});

$btnplay.on('click', function(){
    const videoID = $(this).data('play-ytb-modal');
    const videoSlug = $(this).data('title-video');

    let videoType = '';
    if($(this).data('video-type')) {
        videoType = $(this).data('video-type');
    }

    open(videoID, videoSlug, videoType);
});

$document.on('keyup', function (e) {
    if (isOpened && e.key === 'Escape') {
        close();
    }
});
